import _ from 'lodash';

import './RestrictBillingFooter.less';
import React, { Component } from 'react';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import PropTypes from 'prop-types';

let BUTTON_STATE;

export default class RestrictBillingFooter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			buttonState: BUTTON_STATE.READY,
			buttonText: 'Restrict Billing Access',
			errorMessage: null
		};
	}

	async enableBillingRestriction() {
		this.setState({
			buttonState: BUTTON_STATE.PENDING
		});

		try {
			await CK.clientSockets.users.emit('enableBillingRestriction');
		} catch (error) {
			if (this._isMounted) {
				this.setState({
					errorMessage: error.message
				});

				this.setState({
					buttonState: BUTTON_STATE.ERROR
				});
			}
		}

		if (this._isMounted) {
			this.setState({
				buttonState: BUTTON_STATE.DONE,
				buttonText: 'Done'
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		const buttonProps = {
			disabled:
				this.props.hasRestrictedBilling ||
				!_.includes([BUTTON_STATE.READY, BUTTON_STATE.ERROR], this.state.buttonState),
			pending: this.state.buttonState === BUTTON_STATE.PENDING,
			text: this.state.buttonText,
			handleClick: this.enableBillingRestriction.bind(this)
		};

		const blurb = `only you (not other family members) can view or update billing information.`;

		return (
			<footer className="RestrictBillingFooter">
				{!this.props.hasRestrictedBilling ? (
					<div>
						<p>Lock down this page so that {blurb}</p>
						<RoundButton size="medium" buttonId={'enableBillingRestriction'} {...buttonProps} />
						{this.state.errorMessage && <p className="errorMessage">{this.state.errorMessage}</p>}
					</div>
				) : (
					<div>
						<p>You have locked down this page so that {blurb}</p>
						<RoundButton size="medium" buttonId={'enableBillingRestriction'} {...buttonProps} />
					</div>
				)}
			</footer>
		);
	}
}

RestrictBillingFooter.propTypes = {
	hasRestrictedBilling: PropTypes.bool
};

BUTTON_STATE = {
	// Submitting
	PENDING: 'pending',

	// Just had an error
	ERROR: 'error',

	// Can be pressed
	READY: 'ready',

	// Just done; show good status
	DONE: 'done'
};
